import axios from 'axios';
import { getSubscriptionAccessState } from './subscriptionAccessStore';
import { notifySubscriptionBlocked } from './utils/subscriptionPlan';

const MUTATING_METHODS = new Set(['post', 'put', 'patch', 'delete']);

let interceptorRegistered = false;

const shouldAllowDespiteReadOnly = (config) => {
  const url = String(config?.url || '').toLowerCase();
  const base = String(config?.baseURL || '').toLowerCase();
  const fullUrl = url.startsWith('http') ? url : `${base}${url}`;
  if (fullUrl.includes('/api/auth/')) return true;
  if (fullUrl.includes('/user/updatemypassword')) return true;
  if (fullUrl.includes('/user/updateme')) return true;
  if (fullUrl.includes('/user/ismailnotification')) return true;
  if (fullUrl.includes('/subscription-expired')) return true;
  return false;
};

export const setupAxiosSubscriptionInterceptor = () => {
  if (interceptorRegistered) return;
  interceptorRegistered = true;

  axios.interceptors.request.use(
    (config) => {
      const access = getSubscriptionAccessState();
      if (access.exempt || !access.readOnly) {
        return config;
      }

      const method = (config.method || 'get').toLowerCase();
      if (!MUTATING_METHODS.has(method)) {
        return config;
      }

      if (shouldAllowDespiteReadOnly(config)) {
        return config;
      }

      notifySubscriptionBlocked();

      return Promise.reject(
        Object.assign(new Error('SUBSCRIPTION_READ_ONLY'), {
          code: 'SUBSCRIPTION_READ_ONLY',
          isSubscriptionBlocked: true,
        })
      );
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const apiMessage = error?.response?.data?.message;
      if (
        error?.response?.status === 403 &&
        typeof apiMessage === 'string' &&
        apiMessage.toLowerCase().includes('subscription')
      ) {
        notifySubscriptionBlocked(apiMessage);
      }
      return Promise.reject(error);
    }
  );
};

export default setupAxiosSubscriptionInterceptor;
